import { useModal } from '@shared/model/useModal';

export const useRemoveAppointmentModal = () => useModal('remove-appointment')